const Texts = {
    moneyUnit:' ریال',
    appName: "شرکت آب و فاضلاب مازندران",
    appCompanyName: "شرکت آب و فاضلاب مازندران",
    asredade: "عصرداده",
    username: "نام کاربری",
    activationCode: "کد فعالسازی",
    name: "نام",
    amount: "مبلغ (ریال)",
    amountPeriod: "مبلغ دوره (ریال)",
    useEnglishNumber: "لطفا از اعداد انگلیسی استفاده کنید",
    useJustEnglishCharacter: "لطفا فقط از حروف لاتین و اعداد استفاده کنید",
    wrong: "خطا",
    version: "ویرایش",
    errorConnectingToServer: "خطا در اتصال به سرور",
    descriptionTouchUs: "وب‌سایت شرکت برق استان مازندران\n( اطلاعات تماس و نشانی در پایین صفحه قرار گرفته است )",
    enterWeb: "ورود به صفحه",
    doNotShowAgain: "عدم نمایش مجدد",
    close: "بستن",
    attention: "توجه",
    attentionBack: "آیا می‌خواهید از صفحه خارج شوید، اگر اطلاعات را ارسال نکرده باشید، هیچ یک از اطلاعات ذخیره نخواهد شد",
    attentionDeleteNotSend: "این درخواست ارسال نشده است در صورت حذف دیگر قابل بازیابی نیست. آیا از حذف این مورد اطمینان دارید؟",
    attentionSendRequest: "آیا از ارسال این درخواست اطمینان دارید؟",
    attentionSaveRequest: "آیا از ذخیره این درخواست اطمینان دارید؟",
    sendActivationCode: "ارسال کد فعالسازی",
    linkToAdminPanel: "سامانه دفاتر پیشخوان",
    verifyActivationCode: "تایید کد فعالسازی",
    registerUser: "ثبت نام",
    ok: "تایید",
    descriptionRotate1: "لطفا گوشی خود را بچرخانید یا در تنظیمات",
    descriptionRotate2: "را فعال نمایید",
    pleaseWait: "لطفا منتظر بمانید",
    rial: "ریال",
    success: "موفق",
    thereIsAProblem: "متاسفانه مشکلی پیش آمده است",
    updateWasSuccessful: "بروزرسانی با موفقیت انجام شد",
    logout: "خروج از حساب کاربری",
    exit: "خروج",
    results: "نتایج",
    guide: "راهنما",
    cancel: "انصراف",
    password: "رمزعبور",
    tryPassword: "تکرار رمزعبور",
    login: "ورود",
    userServices: "خدمات مشترکین",
    settings: "مدیریت",
    contactUs: "ارتباط با ما",
    designAndProduction: "طراحی و تولید",
    descriptionLogout: "آیا می خواهید از حساب کاربری خود خارج شوید؟",
    billId: "شناسه قبض",
    beMerge: "ادغامی",
    inquiry: "استعلام",
    branchInformation: "اطلاعات انشعاب",
    nameOfUser: "نام مشترک",
    energyDebt: "بدهی انرژی",
    voltageType: "نوع ولتاژ",
    kiloWatt: "کیلو وات",
    geographicalArea: "محدوده جغرافیایی",
    city: "شهر",
    village: "روستا",
    address: "نشانی محل",
    damageInfo: "اطلاعات خسارت",
    letterInfo: "اطلاعات نامه",
    theftInfo: "اطلاعات سرقت",
    phase: "فاز",
    pollVotes: "نتایج نظرسنجی",
    form: "فرم",
    declareMeterConsumption: "اعلام کارکرد کنتور",
    replyToInquiry: "پاسخ به استعلام مالکیت انشعاب آب",
    changeSpecifications: "تغییر مشخصات مشترکین آب و فاضلاب",
    changeAccountType: "سرویس تغییر کاربری",
    meterTest: "آزمایش کنتور آب",
    disconnectionBranch: "قطع موقت و وصل انشعاب آب",
    debtSettlement: "تسویه حساب بدهی مشترکین آب و فاضلاب",
    billReviewRequest: "درخواست بررسی صورتحساب مشترکین آب و فاضلاب",
    payList: "مشاهده سوابق صورتحساب‌ها و پرداختی‌های مشترکین آب و فاضلاب",
    amprage: "آمپراژ",
    tariffType: "نوع تعرفه",
    tel: "تلفن ثابت",
    postalCode: "کد پستی",
    downloadBill: "دریافت قبض",
    welcomeLogin: "به سامانه شرکت توزیع نیروی برق خوش آمدید",
    newInquiry: "استعلام مجدد",
    requestForm: "فرم درخواست",
    showAnalyzedResults: "نمایش تحلیلی نتایج",
    firstName: "نام",
    lastName: "نام خانوادگی",
    companyName: "نام شرکت",
    record: "ثبت",
    recordRequest: "ارسال و ثبت درخواست",
    saveRequest: "ثبت درخواست",
    notSendJustSaveInfo: "عدم ارسال و تنها ذخیره اطلاعات",
    cellphone: "تلفن همراه",
    description: "توضیحات",
    nationalId: "کد ملی",
    email: "پست الکترونیک",
    correspondenceAddress: "آدرس مکاتبات",
    correspondencePostalCode: "کد پستی مکاتبات",
    userManagement: "مدیریت کاربرها",
    systemManagement: "مدیریت سیستم",
    users: "فهرست کاربرها",
    groups: "فهرست گروه‌ها",
    region: "منطقه",
    bankInfo: "اطلاعات بانکی",
    addressOutage: "نشانی محل خاموشی",
    regions: "فهرست منطقه ها",
    offices: "فهرست دفاتر الکترونیک",
    addUser: "افزودن کاربر جدید",
    addGroup: "افزودن گروه جدید",
    addRegion: "افزودن منطقه جدید",
    addOffice: "افزودن دفتر الکترونیک جدید",
    editUser: "ویرایش کاربر",
    editGroup: "ویرایش گروه",
    editRegion: "ویرایش منطقه",
    editOffice: "ویرایش دفتر الکترونیک",
    isNeedFingerprinting: "آیا نیاز به انگشت نگاری دارد؟",
    needFingerprinting: "نیاز به انگشت نگاری دارد",
    notNeedFingerprinting: "نیاز به انگشت نگاری ندارد",
    office: "دفتر خدمات الکترونیک",
    officeName: "نام دفتر خدمات",
    officeTel: "شماره دفتر خدمات",
    officeAddress: "آدرس دفتر خدمات الکترونیک",
    whichOffice: "کاربر عضو کدام دفتر خدمات الکترونیک است؟",
    whichGroup: "کاربر عضو کدام گروه است؟",
    group: "گروه",
    noOption: "موردی یافت نشد",
    access: "دسترسی ها",
    status: "وضعیت",
    sendStatus: "وضعیت ارسال",
    code: "کد",
    isThisRegionActive: "آیا این منطقه فعال باشد؟",
    isThisOfficeActive: "آیا این دفتر خدمات الکترونیک فعال باشد؟",
    isThisGroupActive: "آیا این گروه فعال باشد؟",
    isThisAdminActive: "آیا این کاربر فعال باشد؟",
    beActive: "فعال باشد",
    beDeactive: "فعال نباشد",
    manager: "نام مدیر",
    delete: "حذف",
    downloading: "در حال دانلود ... ",
    all: "همه",
    date: "تاریخ",
    dateRequestRecord: "تاریخ ثبت درخواست",
    auditDate: "تاریخ بررسی",
    planeOutage: "بابرنامه بودن خاموشی",
    recordUser: "کاربر ثبت کننده",
    fileNumber: "شناسه قبض",
    requesterInfo: "مشخصات درخواست دهنده",
    info: "اطلاعات",
    recordDate: "تاریخ ثبت",
    reason: "علت",
    time: "زمان",
    damageTime: "زمان خسارت",
    theftTime: "زمان سرقت",
    hour: "ساعت",
    minute: "دقیقه",
    damagesList: "موارد آسیب دیده",
    bank: "نام بانک",
    channelType: "کانال پرداخت",
    traceNumber: "شماره پیگیری",
    job: "شغل",
    visitCount: "دفعات مراجعه",
    age: "سن",
    noPayment: "پرداختی موجود نیست",
    noInfo: "اطلاعاتی موجود نیست",
    billSerial: "سریال صورتحساب",
    issueDate: "تاریخ صدور صورتحساب",
    prevReadingDate: "تاریخ قرائت قبلی",
    currentReadingDate: "تاریخ قرائت فعلی",
    readingDate: "تاریخ قرائت",
    normalConsumption: "مصرف میان باری",
    peakConsumption: "مصرف اوج باری",
    lowConsumption: "مصرف کم باری",
    weekendConsumption: "مصرف جمعه",
    reactiveConsumption: "مصرف راکتیو",
    demandConsumption: "قدرت قرائت شده",
    averageConsumption: "متوسط مصرف 30 روزه",
    real: "حقیقی",
    legal: "حقوقی",
    refCode: "کد رهگیری",
    imageOfDamage: "تصویر محل خسارت",
    imageOfLetter: "تصویر نامه",
    imageOfTheft: "تصویر محل وقوع سرقت",
    fatherName: "نام پدر",
    birthCertificateId: "شماره شناسنامه",
    issuePlace: "محل صدور",
    companyRegistrationId: "شماره ثبت",
    businessCode: "کد فعالیت",
    companyCode: "کد موسسه",
    newspaperNumber: "شماره روزنامه رسمی",
    newspaperDate: "تاریخ روزنامه رسمی",
    economicCode: "شناسه ملی",
    man: "مرد",
    woman: "زن",
    selectGender: "جنسیت فرد را مشخص کنید",
    contactInfo: "اطلاعات تماس",
    realOrLegal: "حقیقی یا حقوقی",
    realOrLegalInfo: "اطلاعات حقیقی یا حقوقی",
    birthDay: "تاریخ تولد",
    noBirthDay: "لطفا تاریخ تولد را مشخص کنید",
    requestsList: "لیست درخواست‌ها",
    myRequestsList: "فهرست درخواست‌های من",
    allRequestsList: "فهرست همه درخواست‌ها",
    logsList: "فهرست لاگ ها",
    serviceType: "نوع سرویس",
    message: "پیام",
    ip: "IP",
    update: "بروزرسانی",
    adminName: "نام کاربر",
    requestInfo: "اطلاعات درخواست",
    selectPhase: "فاز درخواستی را انتخاب کنید",
    selectVoltageType: "نوع ولتاژ را انتخاب کنید",
    selectTariffType: "نوع تعرفه را انتخاب کنید",
    selectRequestType: "نوع درخواست را انتخاب کنید",
    receipt: "رسید",
    billInfo: "اطلاعات قبض",
    officeInfo: "اطلاعات دفتر خدمات",
    requestFormInfo: "اطلاعات فرم درخواست",
    nameEmployee: "نام کارمند",
    numberOfBranches: "تعداد انشعاب",
    requested: "درخواستی",
    requestedBranchInfo: "اطلاعات انشعاب های درخواستی",
    currentBranchInfo: "اطلاعات انشعاب موجود",
    currentBranchesInfo: "اطلاعات انشعاب های موجود",
    currentBranch: "انشعاب موجود",
    current: "موجود",
    areYouSureRecordThisRequest: "آیا از ثبت این درخواست اطمینان دارید؟",
    add: "افزودن",
    print: "چاپ",
    gender: "جنسیت",
    row: "ردیف",
    showReceiptAndPrint: "مشاهده رسید و چاپ",
    paymentDate: "تاریخ پرداخت",
    activeNormalRead: "رقم کارکرد میان باری",
    activePeakRead: "رقم کارکرد اوج بار",
    activeLowRead: "رقم کارکرد کم باری",
    activeWeekendRead: "رقم کارکرد جمعه",
    reactiveNormalRead: "رقم کارکرد راکتیو",
    readDemand: "دیماند قرائت شده",
    uploadImages: "بارگذاری تصاویر",
    uploadImage: "بارگذاری تصویر",
    imagesUploadedSuccessfully: "تصاویر با موفقیت بارگذاری شدند",
    continue: "ادامه",
    fax: "فاکس",
    education: "تحصیلات",
    neighborBillId: "شناسه قبض همسایه",
    representativeName: "نام نماینده شرکت",
    representativeLetterNumber: "شماره معرفی نامه",
    outageServices: "خدمات خاموش‌یار",
    outageList: "لیست خاموشی‌ها",
    representativeNationalId: "شماره ملی نماینده شرکت",
    representativeFatherName: "نام پدر نماینده شرکت",
    letterDate: "تاریخ معرفی نامه",
    orderDetailTypes: "موضوع تقاضا",
    search: "جستجو",
    toDate: "تا تاریخ",
    damageDate: "تاریخ خسارت",
    letterDate2: "تاریخ نامه",
    theftDate: "تاریخ سرقت",
    fromDate: "از تاریخ",
    number: "تعداد",
    sent: "ارسال شده",
    notSent: "ارسال نشده",
    noPermission: "این سرویس برای شما فعال نمی باشد",
    completion: "تکمیل",
    show: "مشاهده",
    get: "دریافت",
    optional: "اختیاری",
    addIncAmper: "افزایش آمپر",
    addDecAmper: "کاهش آمپر",
    pleaseChoiceAQuestion: "لطفا یکی از سوالات را انتخاب کنید",
    measurementSubject: "محور سنجش",
    question: "پرسش",
    accountNumber: "شماره حساب",
    cardNumber: "شماره کارت بانک",
    sheba: "شماره شبا",
    accountName: "نام صاحب حساب",
    legalStatus: "وضعیت قانونی",
    letterNumber: "شماره نامه",
    letterSubject: "موضوع نامه",
    letterFrom: "فرستنده نامه",
    letterTo: "گیرنده نامه",
    letterSummary: "خلاصه نامه",
    failedRecaptcha: "لطفا تایید کنید که ربات نیستید",
    propertyDocument: "تصویر سند ملک",
    buildingPermit: "تصویر پروانه ساختمانی",
    birthCertificateCard: "تصویر شناسنامه",
    neighborBill: "تصویر قبض آب‌بها مشترک مجاور",
    documentsImage: "تصویر مدارک",
    errorNoImage: "لطفا با زدن بروی علامت « + » تصاویر را انتخاب کنید",
    legalFacilitiesRequestType: "نوع درخواست تسهیلات قانونی",
    constructionDocumentType: "نوع سند ملک",
    neighborBillPic: "تصویر قبض آب‌بها مشترک مجاور",
    constructionLicensePic: "تصویر پروانه ساختمانی",
    legalFacilitiesPic: "تصویر تسهیلات قانونی",
    constructionDocumentPic: "سند نوع ملک و متن قرارداد",
    evaluationReportPic: "عکس گزارش‌ارزیابی",
    notSentRequest: "درخواست‌های ارسال‌نشده",

    newRequest: "درخواست‌ جدید",
    numberOfUnits: "تعداد واحد",
    accountTypes: "نوع کاربری",
    accountSubTypes: "نوع کاربری فرعی",
    area: "متراژ",
    currentUsage: "کاربری مورد استفاده",
    prevReadingNumber: "رقم قرائت قبلی",
    activeNowNumber: "رقم کارکرد فعلی کنتور",
    ConstructionDocumentPic: "تصوير سند ملک",
    nationalCardPic: "تصویر کارت ملی",
    documentPic: "تصویر مدارک لازم",
    birthCertificatePic: "تصویر شناسنامه",
    reviewType: "نوع بررسی",
    successTraceNumber: "درخواست با موفقیت ثبت شد\nشماره پیگیری: ",
    alarmGetHelp: {
        part1: "آیا می خواهید راهنما سرویس ( ",
        part2: " ) را دریافت کنید؟"
    },
    alarmHaveDebt: {
        part1: "این قبض با شناسه قبض ",
        part2: " دارای بدهی ",
        part3: " ریال می باشد\nلطفا قبل از ثبت درخواست ، بدهی قبض را پرداخت نمایید"
    },
    enquiryOrderInfoMessage: {
        part1: "این درخواست در مرحله ( ",
        part2: " ) قرار دارد"
    },
    deleteAdminMessage: {
        part1: "آیا از حذف این کاربر ( ",
        part2: " ) اطمینان دارید؟"
    },
    deleteGroupMessage: {
        part1: "آیا از حذف این گروه ( ",
        part2: " ) اطمینان دارید؟"
    },
    deleteGroupMessageReally: {
        part1: "با حذف این گروه تمامی کاربران شامل آن نیز حذف می شوند. \nآیا از حذف این گروه ( ",
        part2: " ) اطمینان دارید؟"
    },
    error: {
        noStatus: "لطفا وضعیت را مشخص کنید",
        notEqualPassword: "رمزهای عبور مطابق نیستند",
        choiceSelects: "لطفا فیلدهای انتخابی را کامل کنید",
        noSelectTypeRequest: "لطفا نوع درخواست را مشخص کنید",
        repetitive: "مورد تکراری است",
        noImage: "تصویری انتخاب نشده است"
    },
    sendedActivationCodePhoneNumber: {
        part1: "کد فعالسازی به شماره ",
        part2: " ارسال گردید"
    },
    pleaseEnterYourNumberAgain: "لطفا شماره تلفن همراه خود را دوباره وارد کنید",
    areYourNumberIsWrong: "شماره تلفن همراه را اشتباه وارد کرده‌اید؟",
    messageIncorrectTxt: {
        username: "لطفا نام کاربری را درست وارد کنید",
        billId: "لطفا شناسه قبض را درست وارد کنید",
        password: "لطفا رمزعبور را درست وارد کنید",
        name: "لطفا نام را درست وارد کنید",
        lastName: "لطفا نام خانوادگی را درست وارد کنید",
        code: "لطفا کد را درست وارد کنید",
        tel: "لطفا تلفن ثابت را درست وارد کنید",
        cellphone: "لطفا تلفن همراه را درست وارد کنید",
        manager: "لطفا نام مدیر را درست وارد کنید",
        address: "لطفا آدرس را درست وارد کنید",
        correspondenceAddress: "لطفا آدرس مکاتبات را درست وارد کنید",
        email: "لطفا ایمیل را درست وارد کنید",
        description: "لطفا توضیحات را درست وارد کنید",
        companyName: "لطفا نام شرکت را درست وارد کنید",
        nationalId: "لطفا کد ملی را درست وارد کنید",
        postalCode: "لطفا کد پستی را درست وارد کنید",
        correspondencePostalCode: "لطفا کد پستی مکاتبات را درست وارد کنید",
        fatherName: "لطفا نام پدر را درست وارد کنید",
        birthCertificateId: "لطفا شماره شناسنامه را درست وارد کنید",
        issuePlace: "لطفا محل صدور را درست وارد کنید",
        companyRegistrationId: "لطفا شماره ثبت را درست وارد کنید",
        businessCode: "لطفا کد فعالیت را درست وارد کنید",
        companyCode: "لطفا کد موسسه را درست وارد کنید",
        newspaperNumber: "لطفا شماره روزنامه رسمی را درست وارد کنید",
        economicCode: "لطفا شناسه ملی را درست وارد کنید",
        refCode: "لطفا کد رهگیری را درست وارد کنید",
        amper: "لطفا آمپراژ را درست وارد کنید",
        kilowatt: "لطفا کیلووات را درست وارد کنید",
        numberOfBranches: "لطفا تعداد انشعاب را درست وارد کنید",
        activeNormalRead: "لطفا رقم کارکرد میان باری را درست وارد کنید",
        activePeakRead: "لطفا رقم کارکرد اوج بار را درست وارد کنید",
        activeLowRead: "لطفا رقم کارکرد کم باری را درست وارد کنید",
        activeWeekendRead: "لطفا رقم کارکرد جمعه را درست وارد کنید",
        reactiveNormalRead: "لطفا رقم کارکرد راکتیو را درست وارد کنید",
        readDemand: "لطفا دیماند قرائت شده را درست وارد کنید",
        neighborBillId: "لطفا شناسه قبض همسایه را درست وارد کنید",
        representativeName: "لطفا نام نماینده شرکت را درست وارد کنید",
        representativeLetterNumber: "لطفا شماره معرفی نامه را درست وارد کنید",
        representativeNationalId: "لطفا شماره ملی نماینده شرکت را درست وارد کنید",
        representativeFatherName: "لطفا نام پدر نماینده شرکت را درست وارد کنید",
        job: "لطفا شغل را درست وارد کنید",
        traceNumber: "لطفا کد رهگیری را درست وارد کنید",
        age: "لطفا سن را درست وارد کنید",
        visitCount: "لطفا دفعات مراجعه را درست وارد کنید",
        activationCode: "لطفا کد فعالسازی را درست وارد کنید",
        date: "لطفا تاریخ را درست وارد کنید",
        region: "لطفا منطقه را درست وارد کنید",
        hour: "لطفا ساعت را با دو رقم وارد کنید",
        minute: "لطفا دقیقه را با دو رقم وارد کنید",
        damagesList: "لطفا موارد آسیب دیده را درست وارد کنید",
        accountNumber: "لطفا شماره حساب را درست وارد کنید",
        cardNumber: "لطفا شماره کارت بانک را درست وارد کنید",
        sheba: "لطفا شماره شبا را درست وارد کنید",
        bank: "لطفا نام بانک را درست وارد کنید",
        accountName: "لطفا نام صاب حساب را درست وارد کنید",
        legalStatus: "لطفا وضعیت قانونی را درست وارد کنید",
        letterNumber: "لطفا شماره نامه را درست وارد کنید",
        letterSubject: "لطفا موضوع نامه را درست وارد کنید",
        letterFrom: "لطفا فرستنده نامه را درست وارد کنید",
        letterTo: "لطفا گیرنده نامه را درست وارد کنید",
        letterSummary: "لطفا خلاصه نامه را درست وارد کنید",
    },
    subRequests: {
        branchRequests: "درخواست های انشعاب",
        sellAmperes: "فروش انشعاب آمپری",
        afterSalesServices: "خدمات پس از فروش",
        permanentCollect: "جمع آوری دائم",
        reinstall: "نصب مجدد",
        temporaryDisconnection: "قطع موقت",
        temporaryCollect: "جمع آوری موقت",
        editBranchService: "اصلاح سرویس انشعاب",
        moveInternal: "تغییر مکان داخلی",
        meterTest: "آزمایش کنتور",
        reconnect: "وصل مجدد",
        addIncOrDecAmper: "درخواست افزایش / کاهش آمپر",
        changeTariff: "درخواست تغییر تعرفه",
        checkoutRequests: "درخواست تسویه حساب",
        billingCalculatorBasedOnSelfDeclarat: "محاسبه صورتحساب بر اساس خود اظهاری",
        addMergeSplitService: "درخواست تفکیک / ادغام",
        billingReview: "درخواست بررسی صورتحساب",
        enquiryOrderInfo: "پیگیری درخواست",

        subscriptionRecords: "سوابق اشتراک",
        exportDuplicateBill: "صدور قبض المثنی",
        historyUserPayment: "سوابق پرداخت مشترک",
        historyUserUseAndCheckout: "سوابق مصرف و صورتحساب مشترک",

        outageServicesAndTechnicalIssues: "خدمات خاموشی‌ و مشکلات فنی",
        // outageServices
        outageServices: "خدمات خاموشی",
        // technicalIssues
        technicalIssues: "مشکلات فنی",
        // otherServices
        otherServices: "سایر خدمات",
        getPlanOutageList: "مشاهده برنامه خاموشی‌های از پيش تعيين شده",
        sendOutageSubscriber: "درخواست رفع خاموشی‌های مشترکین",
        sendVoltageRequest: "درخواست رفع مشکل ولتاژ شبکه برق",
        sendLightRequest: "درخواست رفع خاموشی معابر",
        sendDamageRequest: "ثبت خسارت وارده به شبکه",
        sendTheftRequest: "ثبت سرقت برق",
        sendPeopleDamageRequest: "ثبت خسارت وارده به مردم",
        sendFrontageRequest: "درخواست رفع حریم",
        sendDangerRequest: "درخواست رفع خطر از تاسیسات",
        getOutageList: "مشاهده خاموشی‌های جاری",
        sendGovernmentRequest: "استعلام شبکه موجود توسط سازمانها و ادارات دولتی",
        sendPlanOutage: "درخواست خاموشی توسط مشترکین",

        userRequests: "درخواست های مشترک",
        changeUserName: "تغییر نام مشترک",
        editName: "درخواست اصلاح نام",
        editInformation: "درخواست اصلاح اطلاعات",
    },

    //services--------------------------
    WaterBranchAssignment: "واگذاری انشعاب آب",
    Accidents: "رسیدگی و رفع مشکلات ناشی از حوادث آب و فاضلاب",
    WasteWaterBranchAssignment: "واگذاری انشعاب فاضلاب",
    ReplyToInquiry: "پاسخ به استعلام",
    ChangeAccountType: "تغییر کاربری",
    ChangeSpecifications: "تغییر مشخصات ( نام،شماره همراه،آدرس و ...)",
    ChangeUnit: "تغییر واحد",
    ChangeCapacityContractualBranching: "تغییر ظرفیت قراردادی انشعاب",
    ChangeBranchDiameter: "تغییر قطر انشعاب",
    MeterSeparation: "تفکیک کنتور",
    MoveMeasuringDevices: "تغییر مکان وسایل اندازه گیری",
    MeterTest: "آزمایش کنتور",
    MeterChange: "تعویض کنتور",
    InstallAdditionalSiphon: "نصب سیفون اضافی",
    TemporaryDisconnectAndConnectBranch: "قطع موقت و وصل انشعاب",
    CollectOrMergeBranch: "جمع آوری یا ادغام انشعاب",
    MidTermBill: "تسویه حساب بدهی مشترکین",
    BillingReview: "بررسی صورتحساب",
    DeclareMeterConsumption: "اعلام کارکرد کنتور",
    SeeHistory: "مشاهده سوابق",//
    BillingPayment: "امکان پرداخت صورتحساب",//
    Suggestions: "پیشنهادات ، انتقادات و بررسی",
    SaleTankerWater: "فروش آب تانکری",
    addBranchDescription:"شما می‌توانید شناسه قبض مورد نظر را از روی قبض آب و فاضلاب مشاهده و انشعاب خود را ثبت نمایید",
    '0': "",
    //----------------------------------
}
export default Texts;